import React, { useState, useEffect } from 'react';
import AuthSystem from './AuthSystem';
import EnhancedStudentDashboard from './EnhancedStudentDashboard';
import TeacherDashboard from '../teacher/TeacherDashboard';
import AdminDashboard from './AdminDashboard';

const BookingApp = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check for existing user session on mount
  useEffect(() => {
    const savedUser = localStorage.getItem('lexora_user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('lexora_user', JSON.stringify(userData));
  };

  const handleLogout = async () => {
    try {
      // Call supabase sign out if available
      const { auth } = await import('../../lib/supabase');
      if (auth && auth.signOut) {
        await auth.signOut();
      }
    } catch (error) {
      console.log('Supabase logout not available or failed:', error);
    }
    
    // Clear local state and storage
    setUser(null);
    localStorage.removeItem('lexora_user');
    
    // Redirect to landing page
    window.location.href = '/';
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!user) {
    return <AuthSystem onLogin={handleLogin} />;
  }

  // Role-based dashboard rendering
  switch (user.role) {
    case 'student':
      return <EnhancedStudentDashboard user={user} onLogout={handleLogout} />;
    case 'teacher':
      return <TeacherDashboard user={user} onLogout={handleLogout} />;
    case 'admin':
      return <AdminDashboard user={user} onLogout={handleLogout} />;
    default:
      return <AuthSystem onLogin={handleLogin} />;
  }
};

export default BookingApp;